import * as alertsActions from './actions';
import reducer from './reducers';
import * as alertsSelectors from './selectors';

export { alertsActions, alertsSelectors };

export default reducer;
